import React from 'react';

export default function PageHero({ label, title, subtitle, variant = 'green' }) {
  return (
    <section className={`page-hero page-hero--${variant}`}>
      <div className="page-hero__pattern" aria-hidden="true" />
      <div className="container page-hero__content">
        <h1 className="page-hero__title anim-fade-up anim-delay-1">{title}</h1>
        {subtitle && <p className="page-hero__subtitle anim-fade-up anim-delay-2">{subtitle}</p>}
      </div>
    </section>
  );
}
